import type { OperationTable } from '../../modules/fluency/deck-report';

const ADDITION_OPERATOR = '+';
const MIN_GRID_SIZE = 9;
const MEDIUM_GRID_SIZE = 19;

type GridDimensions = {
  maxColumns: number;
  maxRows: number;
  totalColumns: number;
  totalRows: number;
};

const getMaxSize = (value: number): number => {
  if (value <= MIN_GRID_SIZE) {
    return MIN_GRID_SIZE;
  }
  if (value <= MEDIUM_GRID_SIZE) {
    return MEDIUM_GRID_SIZE;
  }
  return value;
};

const getGridDimensions = (
  operator: string,
  tableFluencyData?: OperationTable[]
): GridDimensions => {
  const totalColumns = tableFluencyData?.length || 0;
  const maxAvailableCard =
    tableFluencyData?.reduce(
      (maxAcrossColumns, column) => {
      const columnMax = column.cards.reduce((maxInColumn, card) => {
        const op1 = card.operand1 ?? 0;
        return op1 > maxInColumn ? op1 : maxInColumn;
      }, 0);
      return columnMax > maxAcrossColumns ? columnMax : maxAcrossColumns;
    }, 0) || 0;
    
  const totalRows = maxAvailableCard;

  if (operator !== ADDITION_OPERATOR) {
    return {
      maxColumns: totalColumns,
      maxRows: totalRows,
      totalColumns,
      totalRows,
    };
  }

  const maxColumns = getMaxSize(totalColumns);
  const maxRows = getMaxSize(totalRows);

  return {
    maxColumns,
    maxRows,
    totalColumns,
    totalRows,
  };
};

export { getGridDimensions };
